import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { CurrencyService } from '@app/core/services/currency.service';
import { DrI18nService } from '@app/core/services/i18n/i18n.service';

@Pipe({
    name: 'drCurrency'
})
export class DrCurrencyFormatPipe extends CurrencyPipe implements PipeTransform {

    constructor(protected dr18nService: DrI18nService, protected currencyService: CurrencyService) {
        super(dr18nService.activeLocale);
    }

    transform(value: string | number,
              currencyCode: string = this.currencyService.activeCurrency.currency_display_name,
              display = '',
              digitsInfo?: string,
              locale: string = this.dr18nService.activeLocale,
              noValueIndicator: string = '-'): any {

        let transFormedValue = super.transform(value, currencyCode, display, digitsInfo, locale);
        transFormedValue = transFormedValue ? transFormedValue.trim() : transFormedValue;

        // 'display' is the property to display the currency code via the parent angular CurrencyPipe which we do not do since we always want the currency on the right.
        // The position of the currency symbol left or right is decided by the locale and cannot be changed without also swapping the decimal separator
        // So for SMP usually below code should be executed since the default set is ''.
        if (!display && currencyCode) {
            transFormedValue = transFormedValue ? `${transFormedValue} ${currencyCode}` : ``;
        }

        return transFormedValue || noValueIndicator;
    }

}
